<script lang="ts" setup>
import RadialProgress from "../timer/RadialProgress.vue";
import { useUserStore } from "../../store/index";

//initialize store
const userStore = useUserStore();
// props

const props = defineProps<{ errorBody: any }>();
</script>

<template>
  <div
    class="rounded-lg px-4 py-4 space-y-3 flex h-full flex-col justify-between"
  >
    <div class="">
      <span class="text-base font-medium text-black dark:text-[#D9D9D9]">
        {{ errorBody.technicalError.title }}
      </span>
    </div>

    <div>
      <span class="text-xs font-normal text-[#1D1D1D] dark:text-[#969A9C]">
        <slot name="body"> {{ userStore.error.message }}</slot>
      </span>
    </div>

    <div class="">
      <div
        class="text-base font-medium flex"
        @click="userStore.error.value = false"
      >
        <RadialProgress :color="errorBody.technicalError.color" />
        <span :class="errorBody.technicalError.color" class="mt-2"
          >DISMISS</span
        >
      </div>
    </div>
  </div>
</template>
